import React from "react";
import { useLocation, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const LABELS = {
  admin: "Admin",
  users: "Users",
  roles: "Roles",
  apps: "Apps",
  matrix: "Permissions Matrix",
  vehicles: "Vehicles",
  "calendar-types": "Calendar Types",
  clients: "Clients",
  settings: "Settings",
  platform: "Platform",
  tenants: "Tenants",
  audit: "Audit",
};

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  const crumbs = parts.map((p, i) => {
    const to = "/" + parts.slice(0, i + 1).join("/");
    return { to, label: LABELS[p] || p };
  });
  const onPlatform = pathname.startsWith("/platform");

  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Breadcrumb"
      className="mb-4 flex items-center gap-1.5 text-xs font-medium text-slate-500"
    >
      <Link to={onPlatform ? "/platform" : "/"} className="hover:text-slate-700">
        {onPlatform ? "Platform" : "Hub"}
      </Link>
      {crumbs
        .filter((c) => !(onPlatform && c.label === "Platform" && c.to === "/platform"))
        .map((c, i, arr) => (
          <React.Fragment key={c.to}>
            <ChevronRight className="h-3 w-3 text-slate-300" />
            {i === arr.length - 1 ? (
              <span className="text-slate-900">{c.label}</span>
            ) : (
              <Link to={c.to} className="hover:text-slate-700">
                {c.label}
              </Link>
            )}
          </React.Fragment>
        ))}
    </nav>
  );
}
